import React, { useState } from 'react'
import { Modal, Form, Col } from 'react-bootstrap'
import constants from '../../../config/constants'
import * as yup from 'yup'
import { Formik } from 'formik'
import {
  createGiftBundle,
  updateGiftBundle
} from '../../../services/giftService'
import { friendlyMessageFor } from '../../../utility/errorHelper'
import { toast } from 'react-toastify'
import { ButtonName } from '../../../config/enums'
import { capitalize } from '../../../utility/stringUtils'

type GiftBundleProps = {
  show: boolean
  type: string
  handleClose: () => void
  giftBundleId?: string
  name?: string
}

const msg = constants.inlineError
const schema = yup.object({
  name: yup.string().required(msg.fieldRequired.replace('%s', 'name')),
  id: yup.string()
})

function GiftBundleModal({
  show,
  handleClose,
  type,
  giftBundleId,
  name
}: GiftBundleProps) {
  const [isSubmitting, setIsSubmitting] = useState(false)

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title data-testid="modal-title">
            {capitalize(type)} Bundle
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {' '}
          <Formik
            validationSchema={schema}
            onSubmit={values => {
              setIsSubmitting(true)
              type === ButtonName.add
                ? createGiftBundle(values.name!)
                    .then(id => {
                      setIsSubmitting(false)
                      window.location.reload()
                    })
                    .catch(error => {
                      setIsSubmitting(false)
                      toast.error(friendlyMessageFor(error), {
                        autoClose: false
                      })
                      console.log(error)
                    })
                : updateGiftBundle(giftBundleId!, values.name!)
                    .then(success => {
                      if (success) {
                        setIsSubmitting(false)
                        window.location.reload()
                      } else {
                        toast.error(friendlyMessageFor(''), {
                          autoClose: false
                        })
                      }
                    })
                    .catch(error => {
                      setIsSubmitting(false)
                      toast.error(friendlyMessageFor(error), {
                        autoClose: false
                      })
                      console.log(error)
                    })
            }}
            initialValues={{
              name: '' || name
            }}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              values,
              errors,
              touched
            }) => (
              <Form noValidate onSubmit={handleSubmit}>
                <Form.Row>
                  <Form.Group as={Col}>
                    <Form.Label className="mochi-edit-modal" htmlFor="name">
                      Bundle name
                    </Form.Label>
                    <Form.Control
                      id="name"
                      type="text"
                      name="name"
                      placeholder="type bundle name"
                      value={values.name || ''}
                      onBlur={handleBlur}
                      isInvalid={touched.name && !!errors.name}
                      isValid={touched.name && !errors.name}
                      onChange={handleChange}
                      data-testid="name"
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.name}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Form.Row>

                <div className="text-center pt-4">
                  <button
                    className="mochi-button white-outlined-modal mr-3"
                    data-testid="cancel-button"
                    onClick={handleClose}
                  >
                    Cancel
                  </button>
                  <button
                    className="mochi-button orange"
                    type="submit"
                    data-testid="submit-button"
                    disabled={isSubmitting ? true : false}
                  >
                    {isSubmitting ? 'Sending...' : 'Save'}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default GiftBundleModal
